import {WorkspaceModelType} from "../stores/WorkspaceStore";
import {Item} from "../API";
import {LocalChangeHistory} from "./LocalChangeHistory";

import {debounce} from "../utils/debounce";
import {parseJsonOrFallback, parseOrFallback} from "../stores/convertors/parseJsonOrFallback";
import {itemToItemMSTSnapshotIn} from "../stores/convertors/itemToItemMSTSnapshotIn";


export const syncItemCreate = (workspaceMST: WorkspaceModelType, serverItem: Item) => {
    const itemMST = workspaceMST.items.get(serverItem.id);
    if (itemMST) {
        return;
    }
    workspaceMST.addItemSync(itemToItemMSTSnapshotIn(serverItem));
}

export const syncItemUpdate = (workspaceMST: WorkspaceModelType, serverItem: Item) => {
    const serverVersion = serverItem._version;

    const itemMST = workspaceMST.items.get(serverItem.id);
    if (!itemMST) {
        return;
    }
    if (itemMST.lastSyncedVersion !== serverVersion) {
        if (!getChangeHistoryForItem(itemMST.id).isChangeLocal(serverItem)) {

            if (!itemMST.isRenaming) {
                itemMST.setName(serverItem.name!);
            }
            itemMST.setChildIds(parseJsonOrFallback(serverItem.childIds));
            itemMST.setParentIds(parseJsonOrFallback(serverItem.parentIds));
            itemMST.setTrashed(serverItem.trashed);
            itemMST.setArchived(serverItem.archived);

            itemMST.setAcknowledgementRequired(!!serverItem.acknowledgementRequired);
            itemMST.setAcknowledgement(parseOrFallback(serverItem.acknowledgement, {}));

            itemMST.setSyncedVersion(serverVersion);
        } else {
            removeStepDebounce(itemMST.id, serverItem.updatedAt!);
        }
    }
}

export const syncItemDelete = (workspaceMST: WorkspaceModelType, serverItem: Item) => {
    const serverVersion = serverItem._version;

    const itemMST = workspaceMST.items.get(serverItem.id);
    if (!itemMST) {
        return;
    }
    if (itemMST.lastSyncedVersion !== serverVersion) {
        if (!getChangeHistoryForItem(itemMST.id).isChangeLocal(serverItem)) {
            workspaceMST.removeItemSync(serverItem.id);
        } else {
            removeStepDebounce(itemMST.id, serverItem.updatedAt!);
        }
    }
}

export const itemChangeHistoryMap = new Map<string, LocalChangeHistory>();

export const getChangeHistoryForItem = (itemId: string) => {
    if (!itemChangeHistoryMap.has(itemId)) {
        itemChangeHistoryMap.set(itemId, new LocalChangeHistory());
    }
    return itemChangeHistoryMap.get(itemId)!;
}

const removeStepDebounce = debounce(
    (itemId: string, step: string) => {
        getChangeHistoryForItem(itemId).removeStep(step);
    },
    2000
)
